export default __webpack_public_path__ + "static/media/huawei.f674b075.svg";